module.exports = __webpack_public_path__ + "static/EPD-lamppost-sensor-data_inside-banner_en-4f7de009d0a005f6d3a180c5726c6e0c.jpg";